import React from 'react';

interface BasicInfoStepProps {
    data: {
        name: string;
        description: string;
        primaryUseCase: string;
    };
    updateData: (data: Partial<any>) => void;
}

const BasicInfoStep: React.FC<BasicInfoStepProps> = ({ data, updateData }) => {
    return (
        <div className="space-y-6">
            <h2 className="text-xl font-medium text-gray-900">Grundinformationen</h2>
            <p className="text-gray-500">
                Lege die grundlegenden Informationen für deinen Chatbot fest. Diese Informationen helfen dir,
                deinen Chatbot zu identifizieren und seinen Hauptzweck zu definieren.
            </p>

            <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name des Chatbots *</label>
                <input
                    type="text"
                    name="name"
                    id="name"
                    value={data.name}
                    onChange={(e) => updateData({ name: e.target.value })}
                    placeholder="z.B. Kundenservice Assistent"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    required
                />
                <p className="mt-1 text-sm text-gray-500">
                    Der Name wird in Unterhaltungen angezeigt und hilft Benutzern, mit deinem Bot zu interagieren.
                </p>
            </div>

            <div>
                <label htmlFor="description" className="block text-sm font-medium text-gray-700">Beschreibung</label>
                <textarea
                    name="description"
                    id="description"
                    rows={3}
                    value={data.description}
                    onChange={(e) => updateData({ description: e.target.value })}
                    placeholder="Beschreibe den Zweck und die Fähigkeiten deines Chatbots"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
                <p className="mt-1 text-sm text-gray-500">
                    Eine kurze Beschreibung hilft dir und anderen Teammitgliedern, den Zweck des Chatbots zu verstehen.
                </p>
            </div>

            <div>
                <label htmlFor="primaryUseCase" className="block text-sm font-medium text-gray-700">Haupteinsatzgebiet *</label>
                <select
                    id="primaryUseCase"
                    name="primaryUseCase"
                    value={data.primaryUseCase}
                    onChange={(e) => updateData({ primaryUseCase: e.target.value })}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                >
                    <option value="customer-service">Kundenservice</option>
                    <option value="sales">Vertrieb</option>
                    <option value="internal">Interne Nutzung</option>
                    <option value="education">Bildung & Training</option>
                    <option value="entertainment">Unterhaltung</option>
                    <option value="other">Sonstiges</option>
                </select>
                <p className="mt-1 text-sm text-gray-500">
                    Die Auswahl des Haupteinsatzgebietes hilft uns, deinen Chatbot optimal zu konfigurieren.
                </p>
            </div>

            <div className="bg-blue-50 p-4 rounded-md">
                <div className="flex">
                    <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <div className="ml-3">
                        <p className="text-sm text-blue-700">
                            Diese Informationen kannst du später jederzeit in den Einstellungen deines Chatbots bearbeiten.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BasicInfoStep;